import React from "react";
import { AlertCircle } from "lucide-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const SubscriptionWarnningModal = ({
  isOpen = true,
  onClose = () => {},
  planType = "Free Trial",
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        style={{ maxWidth: "600px" }}
      >
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "18px", overflow: "hidden" }}
        >
          {/* HEADER ICON */}
          <div className="text-center mt-4">
            <div
              className="d-flex align-items-center justify-content-center mx-auto rounded-circle shadow"
              style={{
                width: "75px",
                height: "75px",
                background: "linear-gradient(135deg, #ffcccc, #ffe5e5)",
                boxShadow: "0 6px 16px rgba(255, 0, 0, 0.3)",
              }}
            >
              <AlertCircle size={38} className="text-danger" />
            </div>
          </div>

          {/* TITLE & DESCRIPTION */}
          <div className="modal-body text-center px-4 pb-2">
            <h4 className="fw-bold mt-3" style={{ fontSize: "20px", color: "#222" }}>
              Trial Plan Ended — Upgrade to Continue
            </h4>

            <p className="text-muted mt-2 mb-3" style={{ fontSize: "15px" }}>
              Your <b>{planType}</b> period has ended.  
              To keep your business running smoothly, retain access to your saved data, and unlock premium features, upgrade your subscription today.
            </p>

            <div className="alert alert-warning d-flex align-items-center justify-content-center gap-2 py-2">
              <AlertCircle size={18} />
              <span className="fw-semibold">
                Don’t lose access — Secure your data by upgrading now
              </span>
            </div>

            {/* OPTIONS */}
            <div className="text-start mt-4 px-2">

              <div className="mb-3">
                <span className="fw-semibold text-dark">• Upgrade to a Paid Plan (Recommended):</span>
                <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
                  Unlock all features, maintain data access, and grow your business without limitations.  
                  Choose the best plan for your needs from our{" "}
                  <a href="/subscription" className="text-primary fw-bold text-decoration-none">
                    Pricing Page
                  </a>.
                </p>
              </div>

              <div className="mb-3">
                <span className="fw-semibold text-dark">• Continue with Free Plan:</span>
                <p className="text-muted mb-1" style={{ fontSize: "14px" }}>
                  Access basic features only. Suitable for personal use, but not ideal for business growth.
                </p>
              </div>

              <div className="mb-2">
                <span className="fw-semibold text-dark">• Need More Time?</span>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                  You can{" "}
                  <span
                    className="text-primary fw-bold"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => navigate("/subscription")}
                  >
                    Extend your trial for 14 more days
                  </span>,  
                  or upgrade now to avoid feature restrictions.
                </p>
              </div>

            </div>
          </div>

          {/* BUTTONS */}
          <div className="modal-footer d-flex justify-content-center border-0 pb-4 pt-2 gap-2">
            <button
              onClick={() => {
                navigate("/subscription");
                onClose();
              }}
              className="btn btn-primary fw-bold px-4 py-2"
              style={{
                borderRadius: "8px",
                minWidth: "180px",
                boxShadow: "0 4px 12px rgba(0, 123, 255, 0.5)",
                transition: "all 0.3s ease",
              }}
            >
              Choose & Upgrade Plan
            </button>
          </div>

          {/* CLOSE BUTTON */}
          <button
            type="button"
            className="btn-close position-absolute"
            style={{ top: "15px", right: "15px" }}
            onClick={onClose}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionWarnningModal;
